import repository from '@/repositories/repository'
const resource = 'consumers'
export default {
  index (consumer, params) {
    return repository.get(`${resource}/${consumer}/loans`, { params })
  },
  store (consumer, data) {
    return repository.post(`${resource}/${consumer}/loans`, data)
  },
  statementOfAccount (consumer, params) {
    return repository.get(`${resource}/${consumer}/loans/statement-of-account`, { params })
  },
  /**
   * Description
   * @param {{consumer: string; consumerLoan: string}} params
   */
  receipt ({ consumer, consumerLoan }) {
    return repository.get(`${resource}/${consumer}/loans/${consumerLoan}/receipt`)
  },
  // count (params) {
  //   return repository.get(`${resource}/count`, { params })
  // },
  update (consumer, { id, data }) {
    return repository.put(`${resource}/${consumer}/loans/${id}/edit`, data)
  },
  delete (id) {
    return repository.delete(`${resource}/loans/${id}`)
  },
  excel (storeId) {
    const conf = {
      headers: {
        Accept: 'application/xlsx',
      },
      responseType: 'blob',
    }
    return repository.get(`consumer-loans/${storeId}/excel`, conf)
  },
  export () {
    return repository.get(`${resource}/loans/export`)
  },
  countExport () {
    return repository.get(`${resource}/loans/export/count`)
  },
  import ({ data, columns, unique }) {
    return repository.post(`${resource}/loans/import`, { data, columns, unique })
  },
  firstOr (data) {
    return repository.post(`${resource}/loans/first-or`, { data })
  },
}
